import Parse from 'html-react-parser';

function BMP20209(props) {
    let svgCode =
    `<svg width="56" height="36" viewBox="0 0 56 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="5" y="4" width="46" height="24" rx="5" fill="${props.fontColour}" fill-opacity="0.6"/>
    </svg>`

    props.svgReturn(98, svgCode, "bmp00209", 56, 36);

    return (
        Parse(svgCode)
    );
}

export default BMP20209;